import * as React from "react";
import { Button, Snackbar, Alert } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";

interface UploadButtonProps {
  onSuccess?: () => void;
  resource?: "materials" | "bom" | "sales" | "stock" | "supplier" | "materialRequest" | "customer" | "prodocProducts";
}

const UploadButton: React.FC<UploadButtonProps> = ({ onSuccess, resource = "materials" }) => {
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5180/api';

  const [notify, setNotify] = React.useState<{ open: boolean; message: string }>({
    open: false,
    message: "",
  });

  const handleClose = () => {
    setNotify({ open: false, message: "" });
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    const token = localStorage.getItem("token");

    const res = await fetch(`${API_URL}/${resource}/import`, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.ok) {
      const errorText = await res.text();
      let errorMsg = "Upload failed: " + errorText;

      try {
        const errorJson = JSON.parse(errorText);
        if (Array.isArray(errorJson.errorSalesOrder) && errorJson.errorSalesOrder.length > 0) {
          errorMsg = "上传格式有误";
          setNotify({ open: true, message: errorMsg });

        } else {
          setNotify({ open: true, message: "Upload successful" });
        }
      } catch {
        // 非 JSON 格式，保持原有提示
      }

      if (onSuccess) {
        onSuccess();
      }
    } else {
      const error = await res.text();
      setNotify({ open: true, message: "Upload failed: " + error });
    }
  };

  return (
    <>
      <Button
        variant="text"
        size="small"
        sx={{
          maxHeight: 27.5, textTransform: 'capitalize', top: '-5px', '& span': {

            marginRight: '2px',
          }
        }}
        startIcon={<UploadIcon />}
        onClick={() => fileInputRef.current?.click()}
      >
        Upload
      </Button>
      <input
        type="file"
        accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />

      <Snackbar
        open={notify.open}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}  // 这里改成你想要的位置
      >
        <Alert onClose={handleClose} severity={notify.message.startsWith('上传失败') ? 'error' : 'success'} sx={{ width: '100%' }}>
          {notify.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UploadButton;
